<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.progress_evaluation'),
                        href: meta.links.index,
                    },

                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form action="" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.categories', 1)" for="progress_evaluation_category_id" />
                            <FormSelect
                                id="progress_evaluation_category_id"
                                required
                                v-model="form.progress_evaluation_category_id"
                                :options="options.categories"
                                optgroups
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.progress_evaluation_category_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.max_score')" for="max_score" />
                            <FormInput
                                required
                                id="max_score"
                                v-model="form.max_score"
                                type="text"
                                name="max_score"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.max_score" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.success_criteria') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.passing_students_percent')"
                                for="passing_students_percent"
                            />
                            <FormInput
                                required
                                id="passing_students_percent"
                                v-model="form.passing_students_percent"
                                type="number"
                                step="1"
                                name="passing_students_percent"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.passing_students_percent" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.average_improvement')" for="average_improvement" />
                            <FormInput
                                required
                                id="average_improvement"
                                v-model="form.average_improvement"
                                type="number"
                                step="1"
                                name="average_improvement"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.average_improvement" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.progress_evaluation_desired_percent')"
                                for="desired_percent"
                            />
                            <FormInput
                                required
                                id="desired_percent"
                                v-model="form.desired_percent"
                                type="number"
                                step="1"
                                name="desired_percent"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.desired_percent" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="$t('messages.progress_evaluation_desired_improvement')"
                                for="desired_improvement"
                            />
                            <FormInput
                                required
                                id="desired_improvement"
                                v-model="form.desired_improvement"
                                type="number"
                                step="1"
                                name="desired_improvement"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.desired_improvement" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>
                        <FormLabel :value="$t('messages.comment')" for="comment" />
                    </div>
                    <p class="mt-1 text-sm leading-5 text-gray-500">
                        {{ $t('messages.information_only_visible_by_teachers') }}
                    </p>
                </template>
                <div class="mt-1">
                    <FormTextarea v-model="form.comment" id="comment" name="comment" class="mt-2 w-full" />
                </div>
                <FormError :value="form.errors.comment" class="mt-2" />
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-3">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';

export default {
    components: {
        FormSelect,
        SubmitFormButton,
        FormInput,
        FormError,
        FormTextarea,
        TitleFieldsFormSection,
        FormLabel,
        PanelPage,
    },
    layout: AdminLayout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                progress_evaluation_category_id: null,
                max_score: 10,
                average_improvement: null,
                passing_students_percent: null,
                comment: null,
                desired_percent: null,
                desired_improvement: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
